/* EBONFORM: pictures that already carry their own studio background fill the whole card edge to edge.
   A picture counts as a studio photo when it is tall (about 4:5) AND its four corners are solid, not
   transparent. Transparent cut-outs, even tall ones, keep their padding on the stone card.
   If the check cannot run (blocked or offline) the picture is treated as a cut-out, which is the safe look. */
(function(){
  var SEL='.efh2-work-card figure img,.efc-card img,.ehm-drop__media img,.pdp-card__img,.efh-search-page__media img,.efc-slide img,.efh2-work-card .efc-media img';
  var cache={};
  function cornersSolid(src){
    if(cache[src])return cache[src];
    cache[src]=fetch(src,{mode:'cors',credentials:'omit'})
      .then(function(r){return r.ok?r.blob():Promise.reject(0)})
      .then(function(b){return createImageBitmap(b)})
      .then(function(bm){
        var w=20,h=25,c=document.createElement('canvas');c.width=w;c.height=h;
        var x=c.getContext('2d',{willReadFrequently:true});x.drawImage(bm,0,0,w,h);
        return [[1,1],[w-2,1],[1,h-2],[w-2,h-2]].every(function(p){return x.getImageData(p[0],p[1],1,1).data[3]>=250});
      })
      .catch(function(){return false});
    return cache[src];
  }
  function apply(img,full){
    img.classList.toggle('ef-full',full);
    var host=img.closest('figure,.efc-media,.ehm-drop__media,.efh-search-page__media,.efc-card__gallery');
    if(host)host.classList.toggle('ef-full-host',full||!!host.querySelector('img.ef-full'));
  }
  function mark(img){
    if(!img||img.tagName!=='IMG'||!img.naturalWidth)return;
    var ratio=img.naturalHeight/img.naturalWidth;
    var src=img.currentSrc||img.src;
    if(!(ratio>1.15&&ratio<1.4)||!src){apply(img,false);return}
    cornersSolid(src).then(function(ok){apply(img,ok)});
  }
  function watch(img){
    if(img.__efFit)return;img.__efFit=1;
    if(img.complete)mark(img);
    img.addEventListener('load',function(){mark(img)});
  }
  function scan(root){
    (root||document).querySelectorAll(SEL).forEach(watch);
  }
  function start(){
    scan();
    new MutationObserver(function(list){
      list.forEach(function(m){
        m.addedNodes.forEach(function(n){
          if(n.nodeType!==1)return;
          if(n.matches&&n.matches(SEL))watch(n);
          if(n.querySelectorAll)scan(n);
        });
      });
    }).observe(document.documentElement,{childList:true,subtree:true});
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start);else start();
})();
